import React from "react";
import { withRouter } from "react-router-dom";
import { withGeneral } from "../../context/mixin/with-general";
import { FaqsContainer } from "./faqs-style";
import FaqsIframe from "../../components/faqs-iframe/faqs-iframe";
import { REACT_APP_OCASO_FORM_URL } from "../../services/url";
import FaqsServices from "../../services/FaqsServices";
import Title02Text from "../../components/components-text/title-02-text";

interface FaqsProps { }

interface FaqsState {
  faqsOcaso: any[],
  loading: boolean,
  error: boolean,
}

class FaqsLayout extends React.Component<FaqsProps, FaqsState> {

  state = {
    faqsOcaso: [],
    loading: true,
    error: false
  };

  componentDidMount() {
    this.getFAQsOcaso();
  }

  getFAQsOcaso = async () => {
    const args = {
      loader: false,
      setLoading: () => {}
    };

    const faqsOcaso = await FaqsServices.getFAQsOcaso(args);
    if (faqsOcaso.error) {
      this.setState({ error: true, loading: false });
      return;
    }
   
    this.setState({ faqsOcaso, loading: false });
  }

  render() {
    const { faqsOcaso, loading, error } = this.state;

    // let url = REACT_APP_OCASO_FORM_URL + "/FormulariosMediadores/FAQ/PreguntasFrecuentes";

    return (
      <FaqsContainer>
        <Title02Text>Preguntas Frecuentes</Title02Text>
        
        { faqsOcaso.length > 0 && 
          <>
            <div className="faq-index">
              <p className="title">Índice</p>
              <ul>
                {faqsOcaso.map((faq:any) => 
                  <li key={`faq-index-${faq.faq_ocaso_order}`}>
                  <a href={`#faq-ocaso-${faq.faq_ocaso_order}`}>{faq.faq_ocaso_order}. {faq.faq_ocaso_title}</a>           
                  </li>   
                )}
              </ul>
            </div>

            <div className="faq-list">
              { faqsOcaso.map((faq:any) =>
                <div key={`faq-list-${faq.faq_ocaso_order}`} id={`faq-ocaso-${faq.faq_ocaso_order}`} className="faq-scroll">
                  <p className="title">{faq.faq_ocaso_order}. {faq.faq_ocaso_title}</p>
                  <div className="content" dangerouslySetInnerHTML={{__html: faq.faq_ocaso_content}}/>
                </div>
              )}
            </div>
          </>
        }

        { !loading && !error && faqsOcaso.length === 0 && <p className="info-text">No hay información disponible para mostrar. Inténtelo más tarde.</p> }

        { error && <p className="info-text">No se ha podido recuperar la información solicitada. Inténtelo más tarde.</p>}

        {/* <FaqsIframe url={url}/> */}
      </FaqsContainer>
    );
  }
}

export default withRouter(withGeneral(FaqsLayout));
